<template>
  <div class="pl-5 pr-5 mt-5">
    <div class="title">
      <v-icon class="indent pr-1">mdi-square-medium</v-icon>
      <span class="">{{ title }}</span>
    </div>

    <div class="font-weight-light mt-3">
      <p>
        Jedná se o mezinárodní e-shop společnosti se sídlem v USA a pobočkou v Londýně.
        Společnost se zabývá výrobou a prodejem různých léčivých kosmetických přípravků.
      </p>
      <p>
        Projekt je postaven na silně modifikovaném open source e-commercial systému OpenCart
        s vlastním CMS a řadou modulů pro podporu zobrazení, dopravy a plateb.
        Stránky e-shopu jsou lokalizovány do 10 jazyků včetně např. Češtiny, Ruštiny, Španělštiny,
        Francouzštiny, Polštiny a dalších.
      </p>

      <div class="subtitle-1 mt-3">
        <span>Přehled vlastností projektu:</span>
      </div>

      <ul class="mt-3">
        <li>
          plná podpora více jazyků a více domén (kromě hlavního e-shopu projekt zahrnuje specializované „satelitní“
          weby se společnou správou produktů, zákazníků, objednávek a dalších součástí systému)
        </li>
        <li>responzivní design</li>
        <li>objednání zboží pouze ve dvou krocích - košik a objednávka</li>
        <li>integrovaný CMS vlastní výroby s plnou podporou více jazyků a více domén</li>
        <li>integrované platební a dopravní systémy PayPal, SagePay, FedEd, Royal Mail, Česká pošta</li>
      </ul>
    </div>

    <ImgCarousel :items="images" @click="click"></ImgCarousel>

  </div>
</template>

<script>
  import { call } from 'vuex-pathify';

  import ImgCarousel from "@/components/ImgCarousel";

  export default {
    name: "SkinCulture",
    components: {
      ImgCarousel
    },
    data () {
      return {
        title: 'Skin Culture Institute Inc. – mezinárodní E-shop',
        images: [
          {
            preview: '/img/refs/skinculture/01_prv.png',
            src: '/img/refs/skinculture/01.png',
            description: 'Titulní stránka e-shopu',
            alt: ''
          },
          {
            preview: '/img/refs/skinculture/02_prv.png',
            src: '/img/refs/skinculture/02.png',
            description: 'Detail produktu',
            alt: ''
          },
          {
            preview: '/img/refs/skinculture/03_prv.png',
            src: '/img/refs/skinculture/03.png',
            description: 'Košík',
            alt: ''
          },
          {
            preview: '/img/refs/skinculture/04_prv.png',
            src: '/img/refs/skinculture/04.png',
            description: 'Objednávka',
            alt: ''
          },
          {
            preview: '/img/refs/skinculture/05_prv.png',
            src: '/img/refs/skinculture/05.png',
            description: 'Seznam objednávek',
            alt: ''
          },
          {
            preview: '/img/refs/skinculture/06_prv.png',
            src: '/img/refs/skinculture/06.png',
            description: 'Seznam objednávek - vzhled na mobilu',
            alt: ''
          },
          {
            preview: '/img/refs/skinculture/07_prv.png',
            src: '/img/refs/skinculture/07.png',
            description: 'Objednávka - vzhled na mobilu',
            alt: ''
          },
        ]
      }
    },
    methods: {
      ...call('imgGallery', ['setItems', 'showGallery']),
      click (item) {
        this.showGallery({
          items: this.images,
          index: item.index,
          title: this.title
        });
      }
    }
  }
</script>

<style scoped>
  a {
    color: rgba(8, 113, 0, 0.87);
    text-decoration: none;
  }
  a:hover {
    border-bottom: 1px solid;
  }
  .indent {
    margin-left: -7px;
    margin-top: -2px;
  }
</style>
